/**
 *  @class
 *  @function TabbedContent
 */
if (!customElements.get('tabbed-content')) {
	class TabbedContent extends HTMLElement {
		static get observedAttributes() {
	    return ['selected-index'];
	  }
	  constructor() {
			super();
	  }

		connectedCallback() {
			this.selectedIndex = this.selectedIndex;
			this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
			this.scroller = this.querySelector('.tabbed-content--scroll');
			this.buttons = Array.from(this.scroller.querySelectorAll('button'));
			this.panels = Array.from(this.querySelectorAll('.tabbed-content--content'));
			this.mobile_media_panels = Array.from(this.querySelectorAll('.tabbed-content--media'));
			this.tl = false;
			if ( this.animations_enabled ) {
				this.tl = gsap.timeline({
					paused: true
				});
			}

			this.buttons.forEach((button, index) => {
				button.addEventListener('click', () => {
					this.selectedIndex = index;
				});
			});
			if (Shopify.designMode) {
	      this.addEventListener('shopify:block:select', (event) => {
					this.selectedIndex = this.buttons.indexOf(event.target);
				});
	    }
		}
		get selectedIndex() {
	    return parseInt(this.getAttribute('selected-index')) || 0;
	  }
	  set selectedIndex(index) {
	    this.setAttribute('selected-index', index);
	  }
		attributeChangedCallback(name, oldValue, newValue) {
	    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
				const oldIndex = parseInt(oldValue);
				const newIndex = parseInt(newValue);

				this.buttons[oldIndex].classList.remove('active');
				this.buttons[newIndex].classList.add('active');

				// Mobile media uses display toggle; switch instantly to avoid timeline conflicts
				if (this.mobile_media_panels[oldIndex]) {
					this.mobile_media_panels[oldIndex].classList.remove('active');
				}
				if (this.mobile_media_panels[newIndex]) {
					this.mobile_media_panels[newIndex].classList.add('active');
				}

				if ( this.animations_enabled && !this.tl.isActive() ) {
					this.transitionFromTo(this.panels[oldIndex], this.panels[newIndex]);
				} else {
					this.panels[oldIndex].classList.remove('active');
					this.panels[newIndex].classList.add('active');
				}

	    }
	  }
		transitionFromTo(oldPanel, newPanel) {
			this.tl
				.clear()
				.to(oldPanel, { autoAlpha: 0, duration: 0.25 })
				.set(oldPanel, { className:"-=active" })
				.set(newPanel, { className:"+=active" })
				.to(newPanel, { autoAlpha: 1, duration: 0.25 });

			this.tl.play();
		}
	}
	customElements.define('tabbed-content', TabbedContent);
}
